import fetchApi from 'services/fetch';
import { pyAPI } from 'constants/api';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  formData: { cardNumber: '', date: '', cvv: '', name: '', autoDebit: '' },
  errors: {
    cardNumber: { value: false, message: 'Búscalo en el frente' },
    date: { value: false, message: 'Búscala en el frente' },
    cvv: { value: false, message: 'Búscalo al reverso' },
    name: { value: false },
  },
};

export const payment = {
  state: { ...initialState },
  reducers: {
    updateFormData(state, payload) {
      return {
        ...state,
        formData: { ...state.formData, ...payload },
      };
    },
    updateError(state, payload) {
      return {
        ...state,
        errors: payload,
      };
    },
    clearStore() {
      return { ...initialState };
    },
  },
  effects: (dispatch) => {
    return {
      async submitPaymentCard({ payload, advPay }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: advPay ? pyAPI.paymentWithoutToken : pyAPI.paymentToken,
          data: { ...payload },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((error) => {
            const errMsg = error?.rawResponse?.errors?.[0]?.userMessage || '';
            dispatch.apiStatus.setRequestFailed({ ...error, message: errMsg });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Submit Payment Order',
                pyAPI.paymentWithoutToken,
                'Submit Payment Order API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Submit Payment Order API'),
            });
            return Promise.resolve({ success: false, error: error?.rawResponse });
          });
      },
      async getPaymentStatus({ payload }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.getPaymentStatus,
          data: { ...payload },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch((error) => {
            const msg = error?.rawResponse?.errors?.[0]?.userMessage || '';
            dispatch.apiStatus.setRequestFailed({ ...error, message: msg });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Get Payment Status',
                pyAPI.getPaymentStatus,
                'Get Payment Status API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Payment Status API'),
            });
            return Promise.resolve({ success: false });
          });
      },
      async createIngenicoSession() {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'GET',
          url: pyAPI.createIngenicoSession,
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch(() => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },

      async updateOrder({ orderId, payload }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'PATCH',
          url: pyAPI.updateLead.replace(':id', orderId),
          data: { ...payload },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch(() => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },

      async dar(_, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'GET',
          url: pyAPI.dar,
          params: {
            documentNumber: state.sales?.lead?.document?.[0]?.id,
            documentType: state.sales?.lead?.document?.[0]?.type?.toLowerCase(),
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, uuid: response?.data?.body?.[0]?.digitalIdentity?.uuid });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            return Promise.resolve({ success: false });
          });
      },

      async enrollment({ payload }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.enrollment,
          data: {
            ...payload,
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, data: response?.data });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
